import Auth from '../Containers/Authentication/Auth';
import Api from './Api';

// returns the first fuel tank for a single truck
class FuelTrucks {
  get(params = {}) {
    const myHeaders = new Headers();
    const endPoint = `v1/fbos/${params.fboId}/fuel_trucks`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    return Api.get(endPoint, {
      headers: myHeaders,
    }).then((response) => {
      const fuelTrucks = response.fuelTrucks;

      const detailPromises = fuelTrucks.map((truck) => {
        const detailEndpoint = `v1/fbos/${params.fboId}/fuel_trucks/${truck.id}/details`;

        return Api.get(detailEndpoint, { headers: myHeaders }).then((detailResponse) => {
          return detailResponse.fuelTruck;
        });
      });

      return Promise.all(detailPromises).then((trucks) => {
        return trucks;
      });
    });
  }
}

export default new FuelTrucks();



// WEBPACK FOOTER //
// ./src/Services/FuelTrucks.js